module.exports = __webpack_public_path__ + "static/media/example-3.1a5deccb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/LPC/example-3.jpg
// module id = 294
// module chunks = 0